<template>
  <Tooltip v-if="showNotAvailable" placement="top">
    <template #trigger>
      <span>N/A</span>
    </template>
    <template #tooltip>
      <div>{{ NOT_AVAILABLE_JOB_TIME_TOOLTIP_TEXT }}</div>
    </template>
  </Tooltip>
  <span v-else>{{ label }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue";

import Tooltip from "@/components/Tooltip.vue";
import CONSTANTS from "@/Constants.js";
import { dollars } from "@/mixins";

// Null is N/A (Job Times tooltip) when job times can't be trusted, else "--".
// A `cost` flips the accounting parentheses: a credit reads as money back.
const props = withDefaults(
  defineProps<{
    value: number | null;
    format?: "cents" | "percent";
    notAvailable?: boolean;
    cost?: boolean;
  }>(),
  { format: "cents", notAvailable: false, cost: false }
);

const { NOT_AVAILABLE_JOB_TIME_TOOLTIP_TEXT } = CONSTANTS;

const showNotAvailable = computed(
  () => props.value === null && props.notAvailable
);
const label = computed(() => {
  if (props.value === null) return "--";
  const amount = Math.abs(props.value);
  const text =
    props.format === "percent" ? `${amount.toFixed(1)}%` : dollars(amount);
  return (props.cost ? props.value > 0 : props.value < 0) ? `(${text})` : text;
});
</script>
